import React from 'react';

const COLLAGE_PHOTO =
  'https://customer-assets.emergentagent.com/job_dc9e3538-f079-41ff-9232-076517c20916/artifacts/0rgr4y0t_image.png';

const ProblemSection = () => {
  return (
    <section className="relative overflow-hidden bg-[#ECE6DF]">
      <div className="relative max-w-[1240px] mx-auto px-6 md:px-10 min-h-[480px] md:min-h-[560px] flex items-center">
        {/* Collage anchored to the right, aligned to the container edge */}
        <div className="hidden md:block absolute right-6 md:right-10 top-0 bottom-0 w-[60%] z-0">
          <img
            src={COLLAGE_PHOTO}
            alt="Project approvals, decisions, notes and material samples scattered everywhere"
            data-testid="problem-collage"
            className="w-full h-full object-contain object-right md:scale-[1.45] origin-right"
            style={{
              maskImage:
                'radial-gradient(135% 130% at 75% 50%, #000 70%, transparent 100%)',
              WebkitMaskImage:
                'radial-gradient(135% 130% at 75% 50%, #000 70%, transparent 100%)',
            }}
          />
        </div>

        {/* Full-width wash so the collage reads as a quiet backdrop (no hard edge) */}
        <div
          className="hidden md:block absolute inset-0 z-[1] pointer-events-none"
          style={{
            background:
              'linear-gradient(to right, #ECE6DF 0%, #ECE6DF 34%, rgba(236,230,223,0.62) 58%, rgba(236,230,223,0.3) 82%, rgba(236,230,223,0.2) 100%)',
          }}
        />

        <div className="relative z-10 max-w-[520px] py-12 animate-[fadeUp_0.8s_ease-out_both]">
          <p
            data-testid="problem-eyebrow"
            className="text-[#7A5A2E] text-[12px] tracking-[0.22em] uppercase mb-8"
          >
            The problem
          </p>

          <h2
            data-testid="problem-headline"
            className="text-[#1F1812] leading-[1.1] tracking-[-0.02em]"
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontWeight: 500,
              fontSize: 'clamp(2.2rem, 4.4vw, 3.5rem)',
            }}
          >
            You already know this problem.
          </h2>

          <div className="mt-10 space-y-5 text-[#4A3F33] text-[16px] leading-[1.7] max-w-[460px]">
            <p><span className="text-[#1F1812] font-semibold">Lost approvals.</span> The client approval that lived in a text thread, and disappeared.</p>
            <p><span className="text-[#1F1812] font-semibold">Lost decisions.</span> The client who "thought we decided on the other tile."</p>
            <p><span className="text-[#1F1812] font-semibold">Fishing for emails.</span> The vendor update buried three weeks deep in a chain.</p>
            <p><span className="text-[#1F1812] font-semibold">Re-work.</span> Sunday evening spent reorganizing what should already be organized.</p>
            <p className="text-[#1F1812] font-medium pt-2">That's not a people problem. Your tools were built for data entry no designer has time to do.</p>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeUp { from { opacity: 0; transform: translateY(18px); } to { opacity: 1; transform: translateY(0); } }
      `}</style>
    </section>
  );
};

export default ProblemSection;
